import type { RouteObject } from 'react-router';

import { LoginPage } from './Login';

/**
 * `/login` — one `RouteObject`, so the file is `.route.tsx` singular.
 *
 * It sits **outside** the console layout route and carries no loader: the guard
 * chain exists to send an operator here, and running it on the screen it
 * redirects to would loop. The half shell is the page's own, for the same
 * reason — every control the console chrome carries assumes a session that does
 * not exist yet.
 *
 * It is also the sign-out target from every page of the console.
 */
export const loginRoute: RouteObject = {
  path: '/login',
  element: <LoginPage />,
};
